<template>
  <div>
    
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("category", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'list Category' }"
        >{{ $tc("category", 1) }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper my-3">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="category_name"
                name="category_name"
                v-validate="'required'"
                v-model="category_name"
                placeholder="."
              />
              <label>{{ $tc("category", 1) }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('category_name')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('category_name')">{{
              errors.first("category_name")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(295, 197)"
                >
                  <div class="text-truncate p-2">
                    {{
                      category_image == ""
                        ? "Please Select Image"
                        : category_image
                    }}
                  </div>
                  <ImageGallery
                    v-bind:propImageName="category_name"
                    v-bind:openModal="showModal"
                    v-bind:set_height="set_height"
                    v-bind:set_width="set_width"
                  ></ImageGallery>
                </label>
                <Tooltip :title=" $tc('logoShouldBeOfDimensionPngJpgJpegSvg') " />
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <textarea v-model="category_description" rows="1"></textarea>
              <label>{{ $tc("category", 1) }} {{ $t("description") }}</label>
            </div>
            <Tooltip :title="$tc('category_description')" />
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="cat_is_active"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Is {{ $t("super") }} {{ $tc("category") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="is_super_category"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="UpdateCategory()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MyCinemaService from "@/services/MyCinemaService";
import ImageGallery from "../../Pages/ImageGallery/imageGalleryModal.vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mapGetters } from "vuex";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      submitted: false,
      category_name: "",
      category_image: "",
      category_description: "",
      is_super_category: true,
      cat_is_active: true,
      cinema_id: null,
      Cinemas: [],
      selectedCinema: undefined,
      selectedCategory: null,

      set_width: null,
      set_height: null,
      showModal: false,
      imgSrc: "",
      cropImg: "",
      filename: "",
    };
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
  },
  watch: {
    finalImagePath(newval) {
      this.category_image = newval;
    },
  },
  beforeMount() {
    const { id } = this.$route.query;
    this.selectedCategory = id;
    //   this.getCinemaList();
    this.getEditCategoryData(id);
  },
  methods: {
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    onDropdownChange: function (item, index) {
      console.log("Cinema", item);
      this.selectedCinema = item;
      this.cinema_id = item.cine_id;
    },
    getEditCategoryData: function (category_id) {
      MyCinemaService.GetSingleCategory({ category_id: category_id })
        .then((response) => {
          const { data } = response;
          console.log("data", response);
          if (data && data.status && data.Records.length > 0) {
            this.category_name = data.Records[0].category_name;
            this.category_image = data.Records[0].category_image;
            this.category_description = data.Records[0].category_description;
            this.cat_is_active =
              data.Records[0].cat_is_active == "Y" ? true : false;
            this.is_super_category =
              data.Records[0].is_super_category == "Y" ? true : false;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    UpdateCategory() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            category_name: this.category_name,
            category_image: this.category_image,
            category_description: this.category_description,
            cat_is_active: this.cat_is_active,
            is_super_category: this.is_super_category,
            category_id: this.selectedCategory,
          };
          console.log("PAYLOAD", payload);
          MyCinemaService.UpdateCategory(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/mycinemas/categories",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/MyCinemas/Category/EditCategory.vue